import { SingleTierTax } from './../../classes/singleTierTax/singleTierTax';
import { rates } from './config';
import { ZelfstandigenAftrekConfig } from './interface';

export class ZelfstandigenAftrek {
    
    tax: number;
    
    constructor(data: ZelfstandigenAftrekConfig) {
        this.tax = new SingleTierTax(rates[data.year], data.income).tax;
    }
    
}
